import styled from 'styled-components';

type Props = {
  alpha?: number;
};

export const Container = styled.div<Props>`
  &.ro-paper {
    padding: 20px 15px;
    background-color: transparent;
    box-shadow: none;
    position: relative;
    &:before {
      width: 100%;
      height: 100%;
      content: '';
      background-color: rgba(255, 255, 255, ${props => props.alpha});
      box-shadow: 0 0 29px 0 rgba(0, 0, 0, ${props => (props.alpha || 1) / 7});
      top: 0;
      left: 0;
      position: absolute;
      transition: 0s all ease-in-out;
    }
  }
`;

export const ContainerInner = styled.div`
  position: relative;
  z-index: 99;
`;
